import { ErrorMessage, Form, Formik } from "formik"
import { Col, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import Button from "@/components/Button/Button"
import TextboxInput from "@/components/Inputs/TextboxInput"
import TextInput from "@/components/Inputs/TextInput"
import { MODALS } from "@/constants/modals"
import { useAddTicketMutation } from "@/queries/mutations/ticketMutations"
import { openTicketSchema } from "@/schemas/ticketSchema"
import { useStore } from "@/zustand/store"

export default function NewTicketModal() {
  const { t } = useTranslation()
  const editModalState = useStore((state) => state.editModalState)

  const addTicketMutation = useAddTicketMutation()

  return (
    <Formik
      initialValues={{
        description: "",
        ticket_attachments: [],
        subject: "",
        priority: "",
        status: "",
      }}
      enableReinitialize
      validationSchema={openTicketSchema}
      onSubmit={(values) =>
        addTicketMutation.mutate(values, {
          onSuccess: () => editModalState(MODALS.tickets.add, undefined),
        })
      }
    >
      {() => {
        return (
          <Form>
            <Row>
              <Col md={12} className="mb-3">
                <TextInput
                  label={t("newTicketModal.subject")}
                  placeholder={t("newTicketModal.subject")}
                  id="subject"
                  name="subject"
                  as="field"
                  error={<ErrorMessage name="subject" />}
                />
              </Col>
              <Col md={12} className="mb-3">
                <TextboxInput
                  label={t("newTicketModal.description")}
                  placeholder={t("newTicketModal.description")}
                  id="description"
                  name="description"
                  as="field"
                  error={<ErrorMessage name="description" />}
                />
              </Col>
            </Row>
            <div className="d-flex justify-content-end">
              <Button
                isLoading={addTicketMutation.isPending}
                className="mt-3 "
                type={"submit"}
              >
                {t("buttons.send")}
              </Button>
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}
